import DotsLoading from 'components/loadings/dotsLoading'
import useGetMoneyPoolManagement from 'pages/fund/fundPage/hooks/useGetMoneyPoolManagement'
import { useParams } from 'react-router-dom'
import FundIcon from 'assets/images/funds/moneypool-2.png'
import Fund2Icon from 'assets/images/funds/moneyPool-1.svg'
import Camera from 'assets/icons/camera/camera'
import { useState } from 'react'
import ChangeImageModal from 'components/modals/changeFundImage'
import Header from 'components/headers/bulletins'
import Body from './body'
export default function SettingInfo() {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const { id } = useParams()
    const { moneyPoolManagement, isLoadingMoneypoolManagement, refetch } =
        useGetMoneyPoolManagement(id)
    return (
        <>
            {!isLoadingMoneypoolManagement && moneyPoolManagement ? (
                <>
                    <Header title="تنظیمات صندوق" />
                    <div className=" w-full flex justify-center">
                        <div
                            className=" relative  my-4"
                            onClick={() => setIsOpen(true)}
                        >
                            <img
                                src={
                                    moneyPoolManagement.custom_avatar
                                        ? moneyPoolManagement.custom_avatar
                                        : moneyPoolManagement.image_id === 2
                                        ? FundIcon
                                        : Fund2Icon
                                }
                                alt="fund"
                                className=" w-32 h-32 rounded-full border-1 border-green-1 p-1"
                                onError={(e) => {
                                    e.currentTarget.onerror = null
                                    e.currentTarget.src =
                                        moneyPoolManagement.image_id === 2
                                            ? FundIcon
                                            : Fund2Icon
                                }}
                            />
                            <div className=" absolute bottom-2 right-3 text-green-1 bg-white">
                                <Camera />
                            </div>
                        </div>
                    </div>
                    <Body
                        name={moneyPoolManagement.name}
                        id={id}
                        bankBalance={Number(moneyPoolManagement.bank_balance)}
                        interval={moneyPoolManagement.interval}
                        shareValue={Number(
                            moneyPoolManagement.share_value_amount
                        )}
                        dayOfDuetion={moneyPoolManagement.day_of_duetion}
                        type={moneyPoolManagement.type}
                        notificationAnnounce={
                            moneyPoolManagement.notification_announce
                        }
                        smsAnnounce={moneyPoolManagement.sms_announce}
                        refetch={refetch}
                        imageId={moneyPoolManagement.image_id}
                    />
                    <ChangeImageModal
                        show={isOpen}
                        onHide={() => setIsOpen(false)}
                        id={id}
                        name={moneyPoolManagement.name}
                        bankBalance={Number(moneyPoolManagement.bank_balance)}
                        interval={moneyPoolManagement.interval}
                        shareValue={Number(
                            moneyPoolManagement.share_value_amount
                        )}
                        dayOfDuetion={moneyPoolManagement.day_of_duetion}
                        type={moneyPoolManagement.type}
                        notificationAnnounce={
                            moneyPoolManagement.notification_announce
                        }
                        smsAnnounce={moneyPoolManagement.sms_announce}
                        refetch={refetch}
                        imageId={moneyPoolManagement.image_id}
                    />
                </>
            ) : (
                <DotsLoading />
            )}
        </>
    )
}
